module.exports = __webpack_public_path__ + "assets/img/f91a863aeaa3abd60f8fdbe3bfb903ad.svg";